import { GetPersonUser, DataVehicles, UserStatus, clubStatus, VehicleStatus } from '@esportal/portal-service';

export const getExpectedAuthenticatedRoute = (userData: GetPersonUser | null, userVehicles?: DataVehicles | null) => {
	const userClimaproStatus = userData?.portalUser?.data?.climapro?.status;
	const userClubIsAccepted = userData?.portalUser?.data?.clubVW?.isAccepted;
	const userClubStatus = userData?.portalUser?.data?.clubVW?.status;

	if (userClimaproStatus === UserStatus.KO || userClimaproStatus === UserStatus.ANONYMOUS) {
		return '/sign-up';
	}

	if (userClimaproStatus === UserStatus.PENDING) {
		return '/pending';
	}

	if (!userClubIsAccepted) {
		return '/acceptance';
	}

	if (userClubStatus !== clubStatus.MEMBER) {
		const vehicleToBeCreated = userVehicles?.vehicles?.find(
			(vehicle) => vehicle.status === VehicleStatus.TO_BE_CREATED,
		);

		if (userVehicles?.vehicles?.length && vehicleToBeCreated) {
			return '/add-vehicle/pending';
		}

		if (userVehicles?.vehicles?.length === 0 && !userVehicles?.orders?.length) {
			return '/no-vehicles';
		}
	} else {
		return '/dashboard'; // solo devolver la ruta del dashboard si es miembro del club
	}

	return '/unexpected-error'; // fallback - estados imposibles
};

export const isAllowedOnboardingRoute = (pathname: string, expectedRoute: string) => {
	if (expectedRoute === '/no-vehicles') {
		return pathname === '/no-vehicles' || pathname === '/add-vehicle';
	}

	return pathname === expectedRoute;
};
